import React from 'react';

const ClientIdContext = React.createContext();

export default ClientIdContext;
